<div class="mb-0050">
    <span class="d-inline txt-14 color--gray" *ngIf="!isSimpleQueryFormat">
      Find entities with
      <button class="link p-0"
              (click)="connectionMatchingButtonClicked()">{{getConnectionMatchingText()}}</button>
    </span>
    <app-date-range-and-users-query-link [dateRange]="createdDateRange"
                                         [userIds]="createdBy"
                                         (itemClicked)="dateRangeAndUsersClicked($event)"
                                         [ngClass]="{'d-inline lowercase': !isSimpleQueryFormat}">
    </app-date-range-and-users-query-link>

</div>
<ng-container *ngIf="selectedEntities.length">
  <mat-chip-listbox class="mb-0050 mt-0050"
                    [selectable]="false"
                    #chipList>
    <mat-chip-option *ngFor="let entity of selectedEntities"
                     [color]="'primary'"
                     [removable]="true"
                     (removed)="onEntityRemoved(entity)"
                     matTooltip="{{entity | fullName}}">{{entity | fullName}}

      <button matChipRemove
              [attr.aria-label]="'remove ' + (entity | fullName)">
        <mat-icon matChipRemove
                  fontSet="far"
                  fontIcon="fa-times"></mat-icon>
      </button>

    </mat-chip-option>
  </mat-chip-listbox>
</ng-container>

<ng-container *ngIf="!hasConnections">
  <app-entity-autocomplete (entitySelected)="onEntitySelected($event)"
                           [campaignId]="campaignId"></app-entity-autocomplete>

  <p class="mt-0 mb-0037 txt-14 color--gray">
    And limit results by:
    <button type="button"
            class="link p-0"
            (click)="toggleFilterOnTagCategoryOrTags()">
      {{uiTagsOrCategoriesLabels[uiTagsOrCategories]}}
    </button>
  </p>

  <app-tags-advanced-combo-input [(ngModel)]="tagsComboRuleSet"
                                 [campaignId]="campaignId"
                                 [targetType]="'EntityConnectionType'"
                                 *ngIf="uiTagsOrCategories === 'tags'">
  </app-tags-advanced-combo-input>
  <app-fields-advanced-combo-input [(ngModel)]="tagCategoryResponsesRuleSet"
                                   *ngIf="uiTagsOrCategories === 'tag_category'"
                                   [campaignId]="campaignId"
                                   [targetType]="'EntityConnectionType'">
  </app-fields-advanced-combo-input>
</ng-container>
<div class="qBuild__inset mt-0075 pt-0025 pb-0025"
     *ngIf="!isSimpleQueryFormat">
  <mat-checkbox class="d-block color--gray--005"
                [checked]="include_inactive"
                (change)="includeInactiveChkChanged($event)">
    <span class="txt-fw-400">Include inactive connections</span>
  </mat-checkbox>
</div>
